<template>
    <div>
        <filter-main-layout
                filter-key="filter-main-tyre-truck"
                :select-fields="getSelectAndSlugSelectFields"
                :disabledValues="getDisabledValues"
                :checkboxes-fields="getCheckboxFields"
                :loading="loading"
                @change="filterValues"
                @submit="searchProducts"
                :reset-link="'/catalog/truck/tyre'"
        >
        </filter-main-layout>
    </div>
</template>

<script>
    import FilterMainLayout from './FilterMainLayout';
    import {mapActions, mapState, mapGetters} from "vuex";

    export default {
        name: "TheFilterMainTyreTruck",
        components: {FilterMainLayout},
        computed: {
          ...mapState('topParamTruckTyreModule', {
            paramInfo: 'paramInfo',
            loading: 'loading'
          }),
          ...mapGetters('topParamTruckTyreModule', {
            getSelectFields: 'getSelectFields',
            getSelectAndSlugSelectFields: 'getSelectAndSlugSelectFields',
            getCheckboxFields: 'getCheckboxFields',
            isCurrentPossible: 'isCurrentPossible',
            getDisabledValues: 'getDisabledValues',
          })
        },
        methods: {
          ...mapActions('topParamTruckTyreModule', {
            filterValues: 'filterValues',
            initializationFilter: 'initializationFilter',
            searchProducts: 'searchProducts'
          })
        },
        mounted() {
          this.initializationFilter();
        }
    }
</script>

<style lang="scss">

</style>